/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class CapiSettingsAPI extends ApiClient {
  constructor() {
    super('wasapi/capi_settings', { accountScoped: true });
  }

  get(inboxId = null) {
    return axios.get(this.url, {
      params: inboxId ? { inbox_id: inboxId } : {},
    });
  }

  update(payload, inboxId = null) {
    return axios.put(this.url, {
      capi: payload,
      ...(inboxId ? { inbox_id: inboxId } : {}),
    });
  }

  conversationStatus(conversationId) {
    return axios.get(
      `${this.baseUrl()}/wasapi/conversations/${conversationId}/capi_status`
    );
  }
}

export default new CapiSettingsAPI();
